export async function shortHash10(str = '') {
  try {
    // 1. 编码字符串为 Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(str.trim().replace(/\s/g, ''));

    // 2. SHA-256 哈希，返回 ArrayBuffer
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // 3. 转 Uint8Array
    const hashArray = new Uint8Array(hashBuffer);

    // 4. 转成二进制字符串，方便用 btoa base64
    let binaryString = '';
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < hashArray.length; i++) {
      binaryString += String.fromCharCode(hashArray[i]);
    }

    // 5. base64 编码 (浏览器自带 btoa)
    let base64String = btoa(binaryString);

    // 6. 去掉尾部的 '=' 填充符号（非必须，减少长度）
    base64String = base64String.replace(/=+$/, '');

    // 7. 截取前10字符输出
    return base64String.slice(0, 10);
  } catch {
    const devHash = `${new Date().getTime()}`;
    return devHash.slice(devHash.length - 10, devHash.length);
  }
}
